import React, {useState, useEffect} from 'react';
import {connect} from 'react-redux'
import moment from 'moment';

import withErrorHandler from '../../../hocs/withErrorHandler'
import { useTheme } from '@emotion/react';
import axios from '../../../httpClients/axios-datamerch'
import SearchCountChart from '../SearchCountChart'
import {SearchHistoryCorrelation} from '../../../components' 

import * as actions from '../../../store/actions'


import {
  CardHeader,
  CardContent,
  Divider,
  Grid,
  TextField,
  IconButton,
  CircularProgress,
  Backdrop,
  FormControlLabel,
  Switch,
  Typography,
  Chip,
  Button,
  Link
} from '@mui/material';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import MemberSelect from '../../Account/MembersSelect'
import { FETCH_SEARCH_COUNTS_SUCCESS } from 'store/actions/actionTypes';
import useClasses from '../../../helpers/useClasses';


const styles = theme => ({
  root: {
    padding: theme.spacing(3)
  },
  content: {
    marginTop: theme.spacing(2)
  },
  backdrop: {
    zIndex: '100'
  }
});

const MerchantInfo = props => {
  const classes = useClasses(styles);
  const { 
    onChange,
    fein,
    legal_name,
    dba,
    city,
    state,
    business_phone,
    business_startdate,
    industry,
    proxied_creator,
    onFEINBlur,
    accounts,
    loading,
    is_dm_admin,
    is_admin,
    account_merchant_subscription_enabled,
    merchant_add,
    has_merchant_subscription,
    onMerchantSubscriptionToggle,
    onFetchSearchCounts,
    search_counts,
    plan_level,
    resource_id
  } = props;
  // useEffect(() => {
  // },[accounts])

  const processData = (search_counts) => {
    let processedData = []
    let tempData = latestWins(search_counts)
    tempData = Object.values(tempData)
    // console.log('tempData', tempData)
    processedData = tempData.sort((a, b) => moment(a.created_at) - moment(b.created_at));

    // console.log('processedData', processedData)
    return processedData
  }

  const latestWins = (search_counts) => {
    let new_search_counts = {}
    for (var i=0; i < search_counts.length; i++){
      new_search_counts[search_counts[i].added_by_account_id] = search_counts[i];
    }

    // console.log('new_search_counts', new_search_counts)
    return new_search_counts
  }

  useEffect(() => {
    if (plan_level === 'PRO'){
      onFetchSearchCounts(fein)
    }
  }, [fein])

  useEffect(() => {
    setProcessedSearchCounts(processData(search_counts))
  }, [search_counts])
  
  const [show_additional_info, setShowAdditionalInfo] = useState(false)
  const [show_search_history, setShowSearchHistory] = useState(false)
  const [processed_search_counts, setProcessedSearchCounts] = useState([])

  const states = [
    {
      value: 'AL',
      label: 'Alabama'
    },
    {
      value: 'AK',
      label: 'Alaska'
    },
    {
      value: 'AZ',
      label: 'Arizona'
    },
    {
      value: 'AR',
      label: 'Arkansas'
    },
    {
      value: 'CA',
      label: 'California'
    },
    {
      value: 'CO',
      label: 'Colorado'
    },
    {
      value: 'CT',
      label: 'Connecticut'
    },
    {
      value: 'DE',
      label: 'Delaware'
    },
    {
      value: 'DC',
      label: 'District of Columbia'
    },
    {
      value: 'FL',
      label: 'Florida'
    },
    {
      value: 'GA',
      label: 'Georgia'
    },
    {
      value: 'HI',
      label: 'Hawaii'
    },
    {
      value: 'ID',
      label: 'Idaho'
    },
    {
      value: 'IL',
      label: 'Illinois'
    },
    {
      value: 'IN',
      label: 'Indiana'
    },
    {
      value: 'IA',
      label: 'Iowa'
    },
    {
      value: 'KS',
      label: 'Kansas'
    },
    {
      value: 'KY',
      label: 'Kentucky'
    },
    {
      value: 'LA',
      label: 'Louisiana'
    },
    {
      value: 'ME',
      label: 'Maine'
    },
    {
      value: 'MD',
      label: 'Maryland'
    },
    {
      value: 'MA',
      label: 'Massachusetts'
    },
    {
      value: 'MI',
      label: 'Michigan'
    },
    {
      value: 'MN',
      label: 'Minnesota'
    },
    {
      value: 'MS',
      label: 'Mississippi'
    },
    {
      value: 'MO',
      label: 'Missouri'
    },
    {
      value: 'MT',
      label: 'Montana'
    },
    {
      value: 'NE',
      label: 'Nebraska'
    },
    {
      value: 'NV',
      label: 'Nevada'
    },
    {
      value: 'NH',
      label: 'New Hampshire'
    },
    {
      value: 'NJ',
      label: 'New Jersey'
    },
    {
      value: 'NM',
      label: 'New Mexico'
    },
    {
      value: 'NY',
      label: 'New York'
    },
    {
      value: 'NC',
      label: 'North Carolina'
    },
    {
      value: 'ND',
      label: 'North Dakota'
    },
    {
      value: 'OH',
      label: 'Ohio'
    },
    {
      value: 'OK',
      label: 'Oklahoma'
    },
    {
      value: 'OR',
      label: 'Oregon'
    },
    {
      value: 'PA',
      label: 'Pennsylvania'
    },
    {
      value: 'PR',
      label: 'Puerto Rico'
    },
    {
      value: 'RI',
      label: 'Rhode Island'
    },
    {
      value: 'SC',
      label: 'South Carolina'
    },
    {
      value: 'SD',
      label: 'South Dakota'
    },
    {
      value: 'TN',
      label: 'Tennessee'
    },
    {
      value: 'TX',
      label: 'Texas'
    },
    {
      value: 'UT',
      label: 'Utah'
    },
    {
      value: 'VT',
      label: 'Vermont'
    },
    {
      value: 'VA',
      label: 'Virginia'
    },
    {
      value: 'WA',
      label: 'Washington'
    },
    {
      value: 'WV',
      label: 'West Virginia'
    },
    {
      value: 'WI',
      label: 'Wisconsin'
    },
    {
      value: 'WY',
      label: 'Wyoming'
    }
  ];

  const provinces = [
    {
      value: 'AB',
      label: 'Alberta'
    },
    {
      value: 'BC',
      label: 'British Columbia'
    },
    {
      value: 'MB',
      label: 'Manitoba'
    },
    {
      value: 'NB',
      label: 'New Brunswick'
    },
    {
      value: 'NL',
      label: 'Newfoundland and Labrador'
    },
    {
      value: 'NT',
      label: 'Northwest Territories'
    },
    {
      value: 'NS',
      label: 'Nova Scotia'
    },
    {
      value: 'NU',
      label: 'Nunavut'
    },
    {
      value: 'ON',
      label: 'Ontario'
    },
    {
      value: 'PE',
      label: 'Prince Edward Island'
    },
    {
      value: 'QC',
      label: 'Quebec'
    },
    {
      value: 'SK',
      label: 'Saskatchewan'
    },
    {
      value: 'YT',
      label: 'Yukon'
    },
    {
      value: 'CANADA',
      label: 'Canada (unspecified)'
    }
  ];

  const toggleAdditionalInformation = () => {
    setShowAdditionalInfo(!show_additional_info)
  }

  const toggleSearchHistory = () => {
    setShowSearchHistory(!show_search_history)
  }

  let membersSelect = null

  if (is_dm_admin && merchant_add){
    membersSelect = (
      <Backdrop className={classes.backdrop} open={true}>
        <CircularProgress color="inherit" />
      </Backdrop>
    )
    if(!loading){
      membersSelect = (
        <MemberSelect
          accounts={accounts || []}
          proxied_creator={proxied_creator}
          label="Add on Behalf of"
          onChange={onChange}
        />
      )
    }
  }

  let subscriptionToggle = null

  if ((is_dm_admin || is_admin) && account_merchant_subscription_enabled){
    subscriptionToggle = (
      <Grid
        size={{xs:12, md:12}}
      >
        <FormControlLabel
          control={<Switch 
            checked={has_merchant_subscription}
            onChange={onMerchantSubscriptionToggle}
            name="merchant_subscription_enabled"
            color="primary"
          />}
          label="Subscription Enabled"
        />
        {is_dm_admin ? <Button variant="contained" href={'./'+resource_id+'/pdf'} target="_blank">Export to PDF</Button> : null}
      </Grid>
    )
  }

  return (
    <React.Fragment>
      <CardHeader
        title="Merchant Information"
        action={subscriptionToggle}
      >

      </CardHeader>
      <Divider />
      <CardContent>
        <Grid
          container
          spacing={3}
        >
          <Grid
            size={{xs:12, md:6}}
          >
            {membersSelect}
          </Grid>
          <Grid
            size={{xs:12, md:12}}
          >
            <TextField
              fullWidth
              helperText="Federal employer identification number or business number"
              label="EIN or BN"
              margin="dense"
              name="fein"
              onChange={(event) => onChange(event, 'fein')}
              required
              value={fein || ''}
              variant="outlined"
              inputProps={{
                'maxLength': '10',
                'minLength': '10',
                'pattern':'.{10,10}'
              }}
              onBlur={(event) => onFEINBlur(event)}
              autoFocus
            />
          </Grid>
          <Grid
            size={{xs:12, md:12}}
          >
            <TextField
              fullWidth
              helperText="Legal name of merchant"
              label="Legal Name"
              margin="dense"
              name="legal_name"
              onChange={(event) => onChange(event, 'legal_name')}
              required
              value={legal_name || ''}
              variant="outlined"
            />
          </Grid>
          <Grid
            size={{xs:12, md:6}}
          >
            <TextField
              fullWidth
              label="City"
              margin="dense"
              name="city"
              onChange={(event) => onChange(event, 'city')}
              required
              value={city || ''}
              variant="outlined"
            />
          </Grid>
          <Grid
            size={{xs:12, md:6}}
          >
            <TextField
              fullWidth
              label="State/Province"
              margin="dense"
              name="state"
              onChange={(event) => onChange(event, 'state')}
              required
              select
              // eslint-disable-next-line react/jsx-sort-props
              SelectProps={{ native: true }}
              value={state || ''}
              variant="outlined"
            >
              <option value="" />
              <optgroup label="United States">
                {states.map(option => (
                  <option
                    key={option.value}
                    value={option.value}
                  >
                    {option.label}
                  </option>
                ))}
              </optgroup>
              <optgroup label="Canada">
                {provinces.map(option => (
                  <option
                    key={option.value}
                    value={option.value}
                  >
                    {option.label}
                  </option>
                ))}
              </optgroup>
            </TextField>
          </Grid>
        </Grid>
      </CardContent>
      <Divider />
      <CardHeader
        title={
          <React.Fragment>
            Additional Information
            <IconButton aria-label="settings" onClick={toggleAdditionalInformation}>
              { show_additional_info ?
                <KeyboardArrowUpIcon />
                : 
                <KeyboardArrowDownIcon />
              }
            </IconButton>
          </React.Fragment>
        }
      />
      {show_additional_info ? 
        <React.Fragment>
          <Divider />
          <CardContent>
            <Grid
              container
              spacing={3}
            >
                <Grid
                  size={{xs:12, md:12}}
                >
                  <TextField
                    fullWidth
                    label="Doing Business As"
                    margin="dense"
                    name="dba"
                    onChange={(event) => onChange(event, 'dba')}
                    value={dba || ''}
                    variant="outlined"
                  />
                </Grid>
                <Grid
                  size={{xs:12, md:12}}
                >
                  <TextField
                    fullWidth
                    label="Business Phone"
                    margin="dense"
                    name="business_phone"
                    onChange={(event) => onChange(event, 'business_phone')}
                    value={business_phone || ''}
                    variant="outlined"
                  />
                </Grid>
                <Grid
                  size={{xs:12, md:6}}
                >
                  <TextField
                    fullWidth
                    label="Business Start Date"
                    margin="dense"
                    name="business_startdate"
                    onChange={(event) => onChange(event, 'business_startdate')}
                    value={business_startdate || ''}
                    variant="outlined"
                  />
                </Grid>
                <Grid
                  size={{xs:12, md:6}}
                >
                  <TextField
                    fullWidth
                    label="Industry"
                    margin="dense"
                    name="industry"
                    onChange={(event) => onChange(event, 'industry')}
                    value={industry || ''}
                    variant="outlined"
                  />
                </Grid>
            </Grid>
          </CardContent>
        </React.Fragment>
      : null
      }
      { !merchant_add ?
      <React.Fragment>
      <Divider />
      { (plan_level === 'PRO' || plan_level === 'BASIC') ? 
      <CardHeader
        title={
          <React.Fragment>
            Search History {(processed_search_counts?.length && plan_level === 'PRO') ? <Chip label={processed_search_counts.length} size="small" variant="outline" className={classes.chip} /> : null }
            <IconButton aria-label="settings" onClick={toggleSearchHistory}>
              { show_search_history ?
                <KeyboardArrowUpIcon />
                : 
                <KeyboardArrowDownIcon />
              }
            </IconButton>
          </React.Fragment>
        }
      />
      : null }
      {show_search_history && (plan_level === 'PRO') ? 
        <React.Fragment>
          <Divider />
          <CardContent>
            <Grid
              container
              spacing={3}
            >
                <Grid
                  size={{xs:12, md:12}}
                >
                  <Typography variant="body1">
                    This merchant has been searched <b>{processed_search_counts.length}</b> times in the last 6 months:
                  </Typography>
                  <br/>
                  {/* {search_counts.map(search_count => (
                    <Typography variant="body1">
                      {moment(search_count.created_at).format('MM/DD/YYYY')} at  {moment(search_count.created_at).format('h:mm a')}
                    </Typography>
                  ))} */}
                  <SearchCountChart
                    search_counts={processed_search_counts}
                  /> 
                </Grid>
                <Grid
                  size={{xs:12, sm:12, lg: 12, xl:12}}
                >
                  <SearchHistoryCorrelation />
                </Grid>
            </Grid>
          </CardContent>
        </React.Fragment>
      : null
      }
      {show_search_history && (plan_level !== 'PRO') ? 
        <React.Fragment>
          <Divider />
          <CardContent>
            <Grid
              container
              spacing={3}
            >
                <Grid
                  size={{xs:12, md:12}}
                >   
                  <Typography variant="h6">
                    <Link color="primary"  href="/pro">Seach history is only available to PRO members.</Link>
                  </Typography>
                </Grid>
                <Grid
                  size={{xs:12, md:12}}
                >
                  <Typography variant="h6">
                    Here's why search history matters:
                  </Typography>
                </Grid>
                <Grid
                  size={{xs:12, sm:12, lg: 12, xl:12}}
                >
                  <SearchHistoryCorrelation />
                </Grid>
            </Grid>
          </CardContent>
        </React.Fragment>
      : null
      }
      </React.Fragment>
      : null
    }
    </React.Fragment>
  );
};

const mapStateToProps = state => {
  return {
    search_counts: state.searchCount.search_counts,
    plan_level: state.auth.user.plan_level
  }
}

const mapDispatchToProps = dispatch => {
  return {
    onFetchSearchCounts: (search) => dispatch(actions.fetchSearchCounts(search))
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(withErrorHandler(MerchantInfo, axios))